<template>
  <aside class="side-bar">
    <img class="how-to-buy-icon" @click="openVideo" src="@/assets/images/home/how-to-buy.webp" />
    <div class="side-content">
      <div class="time-block">UTC+8</div>
      <div class="time">{{ state.hourString }}</div>
      <div class="tool-list">
        <!-- 购物车 -->
        <CartList placement="left" :size="30" />
        <!-- 扫码下载 -->
        <el-popover
          placement="left-start"
          width="310px"
          popper-class="download-popover"
          :offset="19"
        >
          <div class="download-app">
            <div class="way-item">
              <img src="@/assets/images/home/google-download-code.png" class="download-logo" />
              <div class="way-logo">
                <img src="@/assets/images/home/google-play-logo.png" />
              </div>
            </div>
            <div class="way-item">
              <img src="@/assets/images/home/apple-download-code.png" class="download-logo" />
              <div class="way-logo">
                <img src="@/assets/images/home/apple-store-logo.png" />
              </div>
            </div>
          </div>
          <template #reference>
            <div class="tool-item border">
              <img class="icon" src="@/assets/images/home/app-phone.png" />
            </div>
          </template>
        </el-popover>

        <div class="tool-item border" v-show="y > 700" @click="goToPageTop">
          <img class="icon back-top" src="@/assets/images/icons/top.svg" />
        </div>
      </div>
    </div>

    <img class="discord-icon" @click="goDiscord" src="@/assets/images/home/discord-icon.png" />
    <div id="service-icon" @click="toggleService">
      <div class="point" v-if="state.unReadCount">{{ state.unReadCount }}</div>
      <div class="icon-wrapper">
        <svg
          style="display: block"
          class="ezchat_icon_open"
          t="1730637661533"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1259"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="30"
          height="30"
        >
          <path
            d="M927.616 465.6C923.328 236.704 745.888 51.808 528 51.808h-32c-217.888 0-395.328 184.896-399.616 413.76C58.112 487.744 32 528.672 32 576v64c0 70.592 57.408 128 128 128s128-57.408 128-128v-64a128.064 128.064 0 0 0-126.784-127.872C173.728 262.688 318.912 115.808 496 115.808h32c177.12 0 322.272 146.88 334.784 332.32A128.064 128.064 0 0 0 736 576v64c0 57.792 38.72 106.176 91.392 122.016a337.504 337.504 0 0 1-191.936 124.48A79.712 79.712 0 0 0 560 832a80 80 0 1 0 0 160 79.68 79.68 0 0 0 67.872-38.112 402.432 402.432 0 0 0 278.24-193.6C955.968 742.816 992 695.776 992 640v-64c0-47.328-26.112-88.256-64.384-110.4zM224 576v64c0 35.296-28.704 64-64 64s-64-28.704-64-64v-64c0-35.296 28.704-64 64-64s64 28.704 64 64z m704 64c0 34.304-27.2 62.176-61.12 63.712l-2.496-1.184c-0.224 0.512-0.576 0.928-0.8 1.408A64 64 0 0 1 800 640v-64c0-35.296 28.704-64 64-64s64 28.704 64 64v64z"
            p-id="1260"
            fill="var(--white-color-1)"
          />
        </svg>
        <svg
          style="display: none"
          class="ezchat_icon_close"
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.601 8.39897C18.269 8.06702 17.7309 8.06702 17.3989 8.39897L12 13.7979L6.60099 8.39897C6.26904 8.06702 5.73086 8.06702 5.39891 8.39897C5.06696 8.73091 5.06696 9.2691 5.39891 9.60105L11.3989 15.601C11.7309 15.933 12.269 15.933 12.601 15.601L18.601 9.60105C18.9329 9.2691 18.9329 8.73091 18.601 8.39897Z"
            fill="white"
          ></path>
        </svg>
      </div>
    </div>
    <VideoModal v-if="state.videoVisible" @close="closeVideo" :is-init="state.isVideoInit" />
  </aside>
</template>

<script setup>
import { useUserStore } from '@/stores'
import { formatTimeStr } from '@/utils/formatTime'
import Intercom, { hide, onHide, onUnreadCountChange, show } from '@intercom/messenger-js-sdk'
import { useWindowScroll } from '@vueuse/core'
import { onMounted, onUnmounted, reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import CartList from '../CartList'
import VideoModal from './VideoModal.vue'

const $route = useRoute()
const userStore = useUserStore()
const state = reactive({
  hourString: '',
  loading: false,
  noGetData: false,
  serviceToggle: false,
  unReadCount: 0,
  videoVisible: false,
  isVideoInit: false,
})
// 初始化视频
const initVideo = () => {
  setTimeout(() => {
    if (state.isVideoInit) {
      $route.path !== '/product' && (state.videoVisible = true)
    }
  }, 500)
}
// 打开视频
const openVideo = () => {
  state.videoVisible = true
}
// 关闭视频
const closeVideo = () => {
  state.videoVisible = false
  state.isVideoInit = false
  userStore.setHomeVideoVisible(false)
}

const timer = setInterval(() => {
  state.hourString = formatTimeStr(Date.now(), 'HH:mm:ss')
}, 1000)
const { y } = useWindowScroll()
const goToPageTop = () => {
  document.documentElement.scrollTop = 0
}

const goDiscord = () => {
  window.open('https://discord.gg/s8BKaDBE2S')
}

const toggleService = () => {
  // window.ezchatF.toggle_ezchat('open');
  // show()
  state.toggleService = !state.toggleService
  if (state.toggleService) {
    show()
  } else {
    hide()
  }
}

const initIntercom = () => {
  const userId = Math.floor(Math.random() * 100000)
  Intercom({
    app_id: 'uhfact1k',
    hide_default_launcher: true,
    right: 80,
    user_id: userStore.profile.id || `${Date.now()}${userId}`, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
    name: userStore.profile.nickName || userStore.profile.userName || `Visiter-${userId}`, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
    email: userStore.profile.email || `Visiter-${userId}`, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
    created_at: Date.now(), // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
  })
  onUnreadCountChange((count) => {
    state.unReadCount = count
  })
  onHide(() => {
    state.toggleService = false
  })
}

onMounted(() => {
  initIntercom()
  initVideo()
})

onUnmounted(() => {
  clearInterval(timer)
})

watch(
  () => userStore.isLogin,
  () => {
    if (userStore.isLogin) {
      initIntercom()
    }
  },
)
</script>

<style lang="scss" scoped>
.side-bar {
  position: fixed;
  right: 15px;
  bottom: 100px;
  width: 58px;
  text-align: center;
  z-index: 1000;

  .side-content {
    box-shadow: 0 2px 6px 0 var(--black-color-2);
    border-radius: 4px;

    overflow: hidden;
  }

  .time-block {
    font-size: 12px;
    background-color: hsla(0, 0%, 94.9%, 0.5);
    padding-top: 7px;
    color: var(--black-color-9);
  }

  .how-to-buy-icon {
    width: 52px;
    margin-bottom: 18px;
    cursor: pointer;
  }

  .time {
    padding: 2px 0 2px;
    font-size: 12px;
    font-weight: 700;
    color: var(--black-color-9);
    line-height: 19px;
    text-align: center;
    background-color: hsla(0, 0%, 94.9%, 0.5);
  }

  .tool-list {
    width: 58px;
    background-color: var(--white-color-1);
    padding-top: 1px;
    padding-bottom: 1px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .tool-item {
      height: 58px;
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;

      &.border {
        border-top: 1px solid #d8d8d8;
      }

      .icon {
        width: 24px;
      }
    }
  }

  .discord-icon {
    cursor: pointer;
    width: 64px;
    // height: 64px;
    margin-top: 70px;
    // border-radius: 50%;
    object-fit: cover;
    // object-position: center;
  }
}

.download-app {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-top: 10px;

  .way-item {
    width: 50%;

    .download-logo {
      width: 138px;
      height: 138px;
      margin-bottom: 12px;
      display: block;
      margin: 0 auto;
    }

    .way-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 48px;
      background: rgba(49, 179, 140, 0.1);
      margin-top: 10px;

      > img {
        width: 95px;
        height: 28px;
      }
    }
  }
}

#service-icon {
  cursor: pointer;
  margin-top: 20px;
  position: relative;

  .point {
    width: 20px;
    height: 20px;
    background-color: #f56c6c;
    position: absolute;
    border-radius: 50%;
    right: 0;
    line-height: 20px;
    text-align: center;
    font-size: 11px;
    color: var(--white-color-1);
  }

  .icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: var(--primary-color);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: var(--white-color-1-light);
  }

  .ezchat_icon_open {
    width: 30px;
    height: 30px;
  }
}
</style>

<style lang="scss">
.download-popover {
  padding: 0 !important;
  border-radius: 8px 0 8px 8px !important;

  .el-popper__arrow {
    display: none;
  }
}
</style>
